import { ChangeEventHandler, memo } from 'react';

import useSWRMutation from 'swr/mutation';

import Checkbox from '@mui/material/Checkbox';

import { userGuideService } from 'v2/api/userGuideService';
import { UserGuideModel } from 'v2/types/UserGuideModel';
import { handleHttpError } from 'v2/utils';

interface UserGuideCheckboxColumnProps {
  guide: UserGuideModel;
  onRevalidate: VoidFunction;
}

export const UserGuideCheckboxColumn = memo<UserGuideCheckboxColumnProps>(({ guide, onRevalidate }) => {
  const { trigger } = useSWRMutation(['markGuideAsDefault', guide.id], userGuideService.markGuideAsDefault, {
    onSuccess: () => {
      onRevalidate();
    },
    onError: handleHttpError,
  });

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    if (e.target.checked) {
      trigger();
    }
  };

  return <Checkbox checked={guide.isDefault} onChange={handleChange} />;
});

UserGuideCheckboxColumn.displayName = 'UserGuideCheckboxColumn';
